import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaMessageBox'

type IcaMessageBoxProps = React.JSX.IntrinsicElements['tgdb-ica-message-box']

export const IcaMessageBox = wrapWc<IcaMessageBoxProps>('tgdb-ica-message-box', [])